"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatch_onClearWebsiteData = void 0;
const thunder_dispatcher_1 = require("../core/thunder-dispatcher");
exports.dispatch_onClearWebsiteData = new thunder_dispatcher_1.ThunderDispatcher('__onClearWebsiteData');
